// src/utils/events/wvdEventUtils.js

// Per fer proves amb altres dates, canviar també la data a:
// voiceAssessmentsRoutes.js

export const getWVDState = () => {
  const now = new Date();
  const year = now.getUTCFullYear();

  const eventStart = new Date(Date.UTC(year, 3, 15, 10, 0, 0));
  const eventEnd = new Date(eventStart.getTime() + 50 * 60 * 60 * 1000);
  const nextEventStart = new Date(Date.UTC(year + 1, 3, 15, 10, 0, 0));

  let phase = 'before';
  if (now >= eventStart && now <= eventEnd) phase = 'active';
  if (now > eventEnd) phase = 'after';

  return { phase, eventStart, eventEnd, nextEventStart };
};